import { GET_FRONT_PAGE } from '../actions/action.types';

export default (state = {}, action) => {
  switch (action.type) {
    case GET_FRONT_PAGE:
      return action.payload || {};
    default:
      return state;
  }
};
